import React from 'react'
import { ListColumnType } from '../../../model/list'
import { Icon } from '@iconify/react'
import { MenuItem, Select, Typography, FormControl } from '@material-ui/core'
import {
  updateCollectionCollaboratorAction,
  deleteCollectionCollaboratorAction,
  deleteCollectionInvitationAction,
} from 'src/reducers/collection/action'
import MyAvatar from 'src/components/MyAvatar'
import { CoreIconButton } from 'src/components/core'
import { ButtonData, ButtonType, ButtonActionType } from 'src/model/button'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import {
  messageBoxShowAction,
  messageBoxHideAction,
} from 'src/reducers/message-box/action'
const CollaboratorTypes = [
  {
    label: 'Editor',
    value: 1,
    description: 'Can create and edit courses and landing pages.',
  },
  {
    label: 'Analyst',
    value: 2,
    description: 'Can view learners data and access analytics.',
  },
  {
    label: 'Editor & Analyst',
    value: 3,
    description:
      'Can create and edit content, manage learners, and view analytics.',
  },
]

const CollboratorType = {
  OWNER: 0,
  ADMIN: 1,
  MEMBER: 2,
}

const columns = [
  {
    attribute: '',
    label: '',
    type: ListColumnType.STRING,
    sortable: false,
    converter: null,
    suffix: null,
    actions: null,
    width: '10%',
    renderer: (entity, history, dispatch) => {
      const firstCharsAtName = entity?.name?.split('')[0]
      const firstCharAtSurname = entity?.surname?.split('')[0]
      const text = firstCharsAtName
        ? firstCharAtSurname
          ? `${firstCharsAtName}${firstCharAtSurname}`
          : firstCharsAtName
        : ''
      return text ? <MyAvatar text={text} size="small" color="gray" /> : '-'
    },
  },
  {
    attribute: 'name',
    label: 'Name',
    type: ListColumnType.STRING,
    sortable: false,
    converter: null,
    suffix: null,
    actions: null,
    renderer: null,
    width: '28%',
  },
  {
    attribute: 'email',
    label: 'Email',
    type: ListColumnType.STRING,
    sortable: false,
    converter: null,
    suffix: null,
    actions: null,
    renderer: null,
    width: '28%',
  },
  {
    attribute: 'type',
    label: 'Role',
    type: ListColumnType.STRING,
    sortable: false,
    converter: null,
    suffix: null,
    actions: null,
    width: '28%',
    renderer: (entity, history, dispatch) => {
      const type = entity?.type
      const status = entity?.status
      const id = window.location.pathname.split('/')[2]
      const inviteStatus = status === 1 ? 'Pending' : 'Accepted'
      if (type !== CollboratorType.OWNER) {
        return inviteStatus === 'Pending' ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 4,
            }}
          >
            <Typography>Pending</Typography>
            <Icon
              icon="fluent:clock-48-regular"
              color="#FFAB00"
              fontSize="18px"
            />
          </div>
        ) : (
          <FormControl
            variant="outlined"
            fullWidth
            style={{
              height: '36px',
            }}
          >
            <Select
              value={type}
              style={{
                height: '36px',
              }}
              onChange={e => {
                if (e.target.value === 'remove') {
                  return
                }
                dispatch(
                  updateCollectionCollaboratorAction(
                    id,
                    entity.userId,
                    { type: e.target.value },
                    () => {},
                  ),
                )
              }}
              renderValue={selected => {
                const selectedRole = CollaboratorTypes.find(
                  role => role.value === selected,
                )
                return selectedRole ? selectedRole.label : ''
              }}
              MenuProps={{
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
                getContentAnchorEl: null,
                PaperProps: {
                  style: {
                    padding: '4px',
                    borderRadius: '8px',
                  },
                },
              }}
            >
              {CollaboratorTypes.map(role => (
                <MenuItem
                  key={role.value}
                  value={role.value}
                  style={{
                    padding: '4px',
                    borderRadius: '8px',
                    marginBottom: '4px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',

                      '&:hover': {
                        backgroundColor: 'none',
                      },
                    }}
                  >
                    <Typography style={{ fontWeight: 500 }}>
                      {role.label}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {role.description}
                    </Typography>
                  </div>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )
      } else {
        return <Typography>Owner</Typography>
      }
    },
  },
  {
    attribute: '',
    label: '',
    type: ListColumnType.STRING,
    sortable: false,
    converter: null,
    suffix: null,
    actions: null,
    width: '10%',
    renderer: (entity, history, dispatch) => {
      const type = entity?.type
      const status = entity?.status
      const id = window.location.pathname.split('/')[2]

      return (
        type !== CollboratorType.OWNER && (
          <CoreIconButton
            color="dark"
            variant="text"
            size="small"
            onClick={() => {
              dispatch(
                messageBoxShowAction(
                  MessageBoxContent({
                    type: MessageBoxType.WARNING,
                    buttons: [
                      new ButtonData(
                        ButtonType.NORMAL,
                        'Cancel',
                        ButtonActionType.NO,
                        e => {
                          dispatch(messageBoxHideAction())
                        },
                      ),
                      new ButtonData(
                        ButtonType.ACTION,
                        'Remove',
                        ButtonActionType.DELETE,
                        e => {
                          dispatch(messageBoxHideAction())
                          status !== 1
                            ? dispatch(
                                deleteCollectionCollaboratorAction(
                                  id,
                                  entity.userId,
                                  () => {},
                                ),
                              )
                            : dispatch(
                                deleteCollectionInvitationAction(
                                  id,
                                  entity.email,
                                  () => {},
                                ),
                              )
                        },
                      ),
                    ],
                    title: 'Remove access to learning path',
                    description: `${entity.email} will immediately lose direct access to this learning path if you continue.`,
                  }),
                ),
              )
            }}
          >
            <Icon icon="bx:trash-alt" />
          </CoreIconButton>
        )
      )
    },
  },
]

export default columns
